export interface PaymentTheme {
  pageBg: string;
  cardBg: string;
  cardBorder: string;
  invoiceBg: string;
  headingColor: string;
  accentColor: string;
  ctaBg: string;
  ctaFg: string;
  noticeBg: string;
  noticeBorder: string;
  noticeFg: string;
  bodyText: string;
  mutedText: string;
};

export const DEFAULT_PAYMENT_THEME: PaymentTheme = {
  pageBg: "#f8fafc",
  cardBg: "#ffffff",
  cardBorder: "#e5e7eb",
  invoiceBg: "#f9fafb",
  headingColor: "#364F6B",
  accentColor: "#3b82f6",
  ctaBg: "#0f172a",
  ctaFg: "#ffffff",
  noticeBg: "#fffbeb",
  noticeBorder: "#fde68a",
  noticeFg: "#b45309",
  bodyText: "#111827",
  mutedText: "#6b7280",
};

/*export const DEFAULT_PAYMENT_THEME: PaymentTheme = {
  pageBg: "#553C9A", // Full page/viewport background
  cardBg: "#F9A8D4", // Main card surface background
  cardBorder: "#EC4899", // Border color around cards
  invoiceBg: "#f9fafb", // Inset order/invoice panel background
  headingColor: "#364F6B", // Section heading text color
  accentColor: "#3b82f6", // Accent for interactive/highlight elements
  ctaBg: "#0f172a", // Primary CTA (Pay button) background
  ctaFg: "#ffffff", // Primary CTA (Pay button) text color
  noticeBg: "#fffbeb", // Notice/banner background
  noticeBorder: "#fde68a", // Notice/banner border color
  noticeFg: "#b45309", // Notice/banner text and icon color
  bodyText: "#111827", // Primary body text color
  mutedText: "#6b7280", // Secondary/muted text color
};*/

/** Merge API partial theme over defaults (safe for unknown keys). */
export function mergePaymentTheme(partial: Partial<PaymentTheme> | null | undefined): PaymentTheme {
  if (!partial || typeof partial !== "object") {
    return { ...DEFAULT_PAYMENT_THEME };
  }
  return { ...DEFAULT_PAYMENT_THEME, ...partial };
}
